// Navbar.jsx
import React, { useEffect, useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [activeSection, setActiveSection] = useState('about');
    const navItems = [
      { label: 'About', href: '#about' },
      { label: 'Skills', href: '#skills' },
      { label: 'Experience', href: '#experience' },
      { label: 'Education', href: '#education' },
      { label: 'Services', href: '#services' },
      { label: 'Certifications', href: '#certifications' },
      { label: 'Projects', href: '#projects' },
    ];

    useEffect(() => {
      const handleScroll = () => setIsScrolled(window.scrollY > 20);
      const sections = [...navItems, { href: '#contact' }]
        .map(item => document.querySelector(item.href))
        .filter(Boolean);
      const observer = new IntersectionObserver(
        entries => entries.forEach(entry => {
          if (entry.isIntersecting) setActiveSection(entry.target.id);
        }),
        { rootMargin: '-25% 0px -65% 0px' }
      );

      window.addEventListener('scroll', handleScroll, { passive: true });
      sections.forEach(section => observer.observe(section));
      return () => {
        window.removeEventListener('scroll', handleScroll);
        observer.disconnect();
      };
    }, []);

    useEffect(() => {
      const closeOnEscape = event => {
        if (event.key === 'Escape') setIsOpen(false);
      };
      document.addEventListener('keydown', closeOnEscape);
      return () => document.removeEventListener('keydown', closeOnEscape);
    }, []);

    const closeMenu = () => setIsOpen(false);

    return (
      <nav
        className={`fixed inset-x-0 top-0 z-50 border-b transition-all duration-300 ${
          isScrolled
            ? 'border-slate-700/70 bg-[#070a0f]/90 py-2 backdrop-blur-xl'
            : 'border-transparent bg-[#070a0f]/60 py-4 backdrop-blur-md'
        }`}
        aria-label="Primary navigation"
      >
        <div className="site-container flex items-center justify-between gap-6">
          <div className="flex items-center gap-3 text-white" aria-label="Hassan Yousuf">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-indigo-400 via-violet-400 to-cyan-300 text-sm font-extrabold text-slate-950">HY</span>
            <span className="hidden text-sm font-bold tracking-tight sm:inline">Hassan Yousuf</span>
          </div>

          <div className="hidden items-center gap-7 md:flex">
            {navItems.map(item => (
              <a
                key={item.href}
                href={item.href}
                className={`focus-ring text-xs font-semibold transition ${
                  activeSection === item.href.slice(1)
                    ? 'text-white'
                    : 'text-slate-400 hover:text-white'
                }`}
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              className={`focus-ring rounded-full px-4 py-2 text-xs font-bold text-slate-950 transition ${
                activeSection === 'contact' ? 'bg-cyan-200' : 'bg-white hover:bg-cyan-200'
              }`}
            >
              Let's connect
            </a>
          </div>

          <div className="flex items-center gap-3 md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="focus-ring rounded-lg border border-slate-700 p-2 text-slate-300"
              aria-expanded={isOpen}
              aria-controls="mobile-navigation"
              aria-label={isOpen ? 'Close navigation menu' : 'Open navigation menu'}
            >
              {isOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </div>

        {isOpen && (
          <div id="mobile-navigation" className="site-container mt-3 space-y-1 border-t border-slate-800 pt-3 md:hidden">
            {navItems.map(item => (
              <a
                key={item.href}
                href={item.href}
                className={`focus-ring block rounded-lg px-3 py-3 text-sm font-semibold transition ${
                  activeSection === item.href.slice(1)
                    ? 'bg-slate-800/80 text-white'
                    : 'text-slate-400 hover:bg-slate-900 hover:text-white'
                }`}
                onClick={closeMenu}
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={closeMenu}
              className={`focus-ring mt-2 block rounded-lg px-3 py-3 text-center text-sm font-bold text-slate-950 ${
                activeSection === 'contact' ? 'bg-cyan-200' : 'bg-white'
              }`}
            >
              Let's connect
            </a>
          </div>
        )}
      </nav>
    );
}
